import React, { useEffect, useState } from "react";
import { Hand, X } from "lucide-react";
import { pill, SAFE_BOTTOM, DOCK_H, GLASS } from "./ui";

const KEY = "jawsel_kota_hint_v1";

// Chip petunjuk sekali tampil (bisa ditutup, hilang sendiri setelah 9 dtk)
export function HintChip() {
  const [show, setShow] = useState(() => !localStorage.getItem(KEY));
  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(dismiss, 9000);
    return () => clearTimeout(t);
  }, [show]); // eslint-disable-line
  if (!show) return null;
  return (
    <div data-testid="kota-hint" style={{ position: "absolute", left: 0, right: 0, bottom: `calc(${SAFE_BOTTOM} + ${DOCK_H + 12}px)`, display: "flex", justifyContent: "center", pointerEvents: "none" }}>
      <div style={{ ...pill, pointerEvents: "auto", fontWeight: 500, fontSize: 12, color: GLASS.sub, paddingRight: 6 }}>
        <Hand size={15} color="#ffd166" />
        <span>Geser · Cubit untuk zoom · Ketuk bangunan</span>
        <button data-testid="kota-hint-close" aria-label="Tutup petunjuk" onClick={dismiss}
          style={{ width: 26, height: 26, borderRadius: 99, border: 0, background: GLASS.inner, color: GLASS.ink, display: "grid", placeItems: "center", cursor: "pointer" }}>
          <X size={13} />
        </button>
      </div>
    </div>
  );
}
